import React from "react";
import { Link } from "react-router-dom";

import Seo from "../seo/Seo";
import {
  organizationSchema,
  webPageSchema,
  breadcrumbSchema,
} from "../seo/schema";
import PageHeader from "../components/PageHeader";
import Breadcrumbs from "../components/Breadcrumbs";
import { useNowIST } from "../lib/useResults";

const PATH = "/terms-and-conditions";

const Terms = () => {
  const nowIST = useNowIST();

  const title = "Terms & Conditions | Bagad Satta Company";
  const description =
    "The terms you agree to when using Bagad Satta Company: acceptable use, accuracy of published results, intellectual property and limitation of liability.";

  const trail = [
    { name: "Home", path: "/" },
    { name: "Terms & Conditions", path: PATH },
  ];

  return (
    <>
      <Seo
        path={PATH}
        title={title}
        description={description}
        schema={[
          organizationSchema(),
          webPageSchema({ path: PATH, title, description }),
          breadcrumbSchema(trail),
        ]}
      />

      <div className="page-banner">
        <div className="container page-padding">
          <Breadcrumbs trail={trail} />
          <PageHeader h1="Terms &amp; Conditions" nowIST={nowIST} />

          <section className="card text-content">
            <h2>Acceptance</h2>
            <p>
              By using this website you accept these terms. If you do not accept
              them, please stop using the site.
            </p>

            <h2>Eligibility</h2>
            <p>
              This website is intended only for people aged 18 or over, and only
              where viewing this kind of information is lawful. You are
              responsible for knowing the law that applies where you live — see
              our <Link to="/disclaimer">disclaimer</Link>.
            </p>

            <h2>Use of the Website</h2>
            <p>
              You may read, print and share the results published here. You may
              not scrape the site at a volume that degrades it for other
              visitors, attempt to break into any part of it, or republish our
              charts as if they were your own.
            </p>

            <h2>Accuracy of Results</h2>
            <p>
              Published numbers are provided in good faith. We mark undeclared
              results as XX rather than guessing, but we do not warrant that
              every published figure is accurate, complete or timely. Verify
              anything important independently.
            </p>

            <h2>No Financial or Legal Advice</h2>
            <p>
              Nothing on this website is financial, legal or betting advice, and
              nothing here is an invitation to gamble.
            </p>

            <h2>Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, we are not liable for any
              loss or damage — financial or otherwise — arising from the use of,
              or reliance on, anything published on this website.
            </p>

            <h2>External Links</h2>
            <p>
              Links to third-party websites and applications are provided for
              convenience. We do not control them and are not responsible for
              their content or their terms.
            </p>

            <h2>Intellectual Property</h2>
            <p>
              The layout, design, written content and presentation of this
              website belong to Bagad Satta Company.
            </p>

            <h2>Changes</h2>
            <p>
              We may revise these terms at any time. The version published on
              this page is the version that applies.
            </p>

            <h2>Contact</h2>
            <p>
              Questions about these terms can be sent from the{" "}
              <Link to="/contact-us">contact page</Link>.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default Terms;
